import { ApplicationsState } from './types';

export const state: ApplicationsState = {
  job: { applications: { edges: [], totalCount: 0 } },
  applicationDetails: { id: '' },
  allStatusTotal: { applications: { edges: [], totalCount: 0 } },
  receivedTotal: { applications: { edges: [], totalCount: 0 } },
  interestedTotal: { applications: { edges: [], totalCount: 0 } },
  notAFitTotal: { applications: { edges: [], totalCount: 0 } },
  showMessageSentNotification: false,
  toastNotificationMessage: '',
  showApplicationLoading: true,
};

export default state;
